import { AnyAction, IPartialReducer } from "../../../core/core-redux/reduxTypes";
import { ChangesType } from "../../types";
import { SAVE_CHANGE_TYPE_COLORING } from "./";
import { updateObject } from "../../../common/util/UpdateObject";

export const changeTypeColoringReducer: IPartialReducer<ChangesType> = (state: ChangesType, action: AnyAction) => {
    if (action.type === SAVE_CHANGE_TYPE_COLORING) {
        return updateObject(state, {
            changeTypeColoring: { changeToColorMapping: action.changeToColorMapping },
        });
    }
    return state ? state : {};
};
